import React from 'react';
import './simplecontainer.styl';

class SimpleContainer extends React.Component {
  //constructor to set the color and optional background image
  constructor(props){
    super(props);
    this.color = props.color;
    this.state = {name: props.containerClass || 'standard'};
    this.style = {
      background: props.backgroundImage && 'url(' + props.backgroundImage + ') ' + (props.backgroundPosition ? props.backgroundPosition : 'center') + ' center',
      backgroundSize: props.backgroundImage && 'cover'
    };
  }

  componentWillReceiveProps(nextProp){
    this.setState({name: nextProp.containerClass || 'standard'});
  }

  render(){
    return (
      <div
        id={ this.props.id }
        className={'row simple-container '+this.color+' '+this.state.name + (this.style.background ? ' has-overlay' : '')}
        style={ this.style }
      >
        {this.props.children}
      </div>
    );
  }
}

export default SimpleContainer;



// WEBPACK FOOTER //
// ./src/containers/simplecontainer/SimpleContainer.js